<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
        <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
          caption="Lista de Tratamientos" icon="fas fa-hand-sparkles" btn_name="Tratamiento" @mtdBack="mtdBack"
          @show_modal="mtd_open_modal" @action_edit="mtd_show" @action_delete="mtd_delete" :size="'lg'"
          :button_new="true" :actions="true" :withActions="'2%'" :buttonEdit="true" :buttonDelete="true" />
      </CCol>
    </CRow>

    <!-- modal store / update -->
    <CModalForm :backdrop="true" :closeOnBackdrop="false" :size="'xl'" :title="modal.title" :button="cp_button"
      :show.sync="modal.modal_form" @mtd_action="mtd_action" :color="'info'" :centered="true">
      <CRow>
        <!-- Datos principales -->
        <CCol sm="12">
          <CInput label="Nombre del Tratamiento" placeholder="Digite nombre" v-model="treatment.name" />
        </CCol>
        <CCol sm="6">
          <cSelectForm label="Tipo de Servicio" placeholder="Seleccione tipo de servicio" :options="data_serviceType"
            :value.sync="treatment.service_type_id" />
        </CCol>
        <CCol sm="6">
          <CInput
            label="Número de Sessiones"
            placeholder="Digite el tiempo"
            v-model="treatment.quotes_quantity"
            type="number"
          />
        </CCol>
        <CCol sm="12" md="12" lg="6">
          <CInput label="Precio de Valor Agregado al Servicio (S/)" placeholder="0.00"
            v-model="treatment.added_value_price" type="number" @input="validateDecimal('added_value_price')" />
        </CCol>
        <CCol sm="12" md="12" lg="6">
          <CInput label="Precio para la Venta (S/)" placeholder="0.00" v-model="treatment.price" type="number"
            @input="validateDecimal('price')" />
        </CCol>

        <!-- Estado solo en update -->
        <CCol v-if="modal.action != 'store'" sm="12">
          <label>Estado</label>
          <CSwitchVue :key="componentKey" @changeSwitch="changeSwitch" class="mx-1 pl-2 pt-2"
            :checked="treatment.state == 1" color="success" variant="opposite" shape="pill" v-bind="labelIcon" />
        </CCol>

        <CCol sm="12">
          <hr />
        </CCol>

        <!-- Buscador de material -->
        <CCol sm="12">
          <label><strong>Materiales del Tratamiento</strong></label>
        </CCol>
        <CCol sm="8">
          <label>Buscar Material</label>
          <v-select v-model="selected_material" :options="cp_available_materials"
            placeholder="Escriba para buscar material..." label="label" :close-on-select="true"
            @input="mtd_on_material_select" />
        </CCol>
        <CCol sm="4" class="d-flex align-items-end">
          <CButton color="success" :disabled="!selected_material" @click="mtd_add_material" class="w-100">
            <i class="fas fa-plus"></i> Agregar
          </CButton>
        </CCol>

        <!-- Preview del material seleccionado -->
        <CCol v-if="selected_material" sm="12" class="mt-2">
          <CRow>
            <CCol sm="3">
              <CInput label="Unidad" :value="preview.unit_name" readonly />
            </CCol>
            <CCol sm="3">
              <CInput label="Cantidad Total" :value="preview.quantity" readonly />
            </CCol>
            <CCol sm="3">
              <CInput label="Precio Total (S/)" :value="preview.price_total" readonly />
            </CCol>
            <CCol sm="3">
              <CInput label="Cant. por Paciente" placeholder="0" v-model="preview.quantity_per_patient" type="number"
                @input="mtd_calc_price_per_patient" />
            </CCol>
          </CRow>
        </CCol>

        <!-- Precio calculado -->
        <CCol v-if="selected_material && preview.price_per_patient > 0" sm="12">
          <div class="alert alert-info py-1 px-3">
            <small>
              Precio por Paciente:
              <strong>S/ {{ preview.price_per_patient }}</strong>
              &nbsp;=&nbsp;
              ({{ preview.price_total }} / {{ preview.quantity }}) × {{ preview.quantity_per_patient }}
            </small>
          </div>
        </CCol>

        <!-- Tabla de materiales agregados -->
        <CCol sm="12" class="mt-3">
          <table class="table table-sm table-bordered table-striped" v-if="treatment.materials.length > 0">
            <thead class="thead-dark">
              <tr>
                <th style="width:3%">#</th>
                <th>Material</th>
                <th style="width:8%">Unidad</th>
                <th style="width:10%">Cant. Total</th>
                <th style="width:11%">Precio Total</th>
                <th style="width:11%">Cant. x Pac.</th>
                <th style="width:11%">Precio x Pac.</th>
                <th style="width:5%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in treatment.materials" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.material_name }}</td>
                <td>{{ item.unit_name }}</td>
                <td>{{ item.quantity }}</td>
                <td>S/ {{ Number(item.price_total).toFixed(2) }}</td>
                <td>{{ item.quantity_per_patient }}</td>
                <td>S/ {{ item.price_per_patient }}</td>
                <td class="text-center">
                  <CButton size="sm" color="danger" @click="mtd_remove_material(index)">
                    <i class="fas fa-trash"></i>
                  </CButton>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="font-weight-bold bg-light">
                <td colspan="6" class="text-right pr-2">Total Parcial:</td>
                <td colspan="2">S/ {{ cp_total_partial }}</td>
              </tr>
              <tr class="font-weight-bold bg-light">
                <td colspan="6" class="text-right pr-2">Precio Final:</td>
                <td colspan="2">S/ {{ cp_final_price }}</td>
              </tr>
            </tfoot>
          </table>
          <div v-else class="text-muted text-center py-3">
            <i class="fas fa-box-open mr-1"></i> Aún no se han agregado materiales
          </div>
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="'Borrar Tratamiento'"
      :show.sync="modal_delete.boo" @mtd_commit="mtd_commit" :centered="true" :item="modal_delete.item" />
  </div>
</template>

<script>
import "vue-select/dist/vue-select.css";

const fields = [
  { key: "index", label: "Id", _style: "width:1%;" },
  { key: "name", label: "Tratamiento", _style: "width:28%;" },
  { key: "total_partial", label: "Total Parcial", _style: "width:12%;" },
  { key: "added_value_price", label: "Val. Agregado", _style: "width:12%;" },
  { key: "final_price", label: "Precio Final", _style: "width:12%;" },
  { key: "price", label: "Precio Venta", _style: "width:12%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../../../components/shared/datatable/Table.vue";
import CModalForm from "../../../components/shared/modals/cModalForm.vue";
import cModalDelete from "../../shared/modals/cModalDelete.vue";
import CSwitchVue from "../../shared/switch/CSwitch.vue";
import { mapActions } from "vuex";
import cSelectForm from "../../../components/shared/inputs/cSelect.vue";

const emptyTreatment = (store) => ({
  id: "",
  company_id: store.getters.get_company.id,
  campu_id: store.getters.get_campu.id,
  service_type_id: "",
  name: "",
  added_value_price: "",
  price: "",
  materials: [],
  quotes_quantity: "",
  state: 1,
});

const emptyPreview = () => ({
  material_id: null,
  material_name: "",
  unit_id: null,
  unit_name: "",
  quantity: 0,
  price_total: 0,
  quantity_per_patient: "",
  price_per_patient: 0,
});

export default {
  components: {
    CTableWrapper,
    CModalForm,
    cModalDelete,
    CSwitchVue,
    cSelectForm
  },
  data() {
    return {
      prefix: "treatment",
      fields,
      data: [],
      data_serviceType: [],
      data_materials: [],
      data_materials_options: [],
      selected_material: null,
      preview: emptyPreview(),
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      treatment: emptyTreatment(this.$store),
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
    };
  },
  computed: {
    cp_button() {
      return !(this.treatment.name && this.treatment.materials.length > 0);
    },
    cp_total_partial() {
      const total = this.treatment.materials.reduce(
        (sum, m) => sum + parseFloat(m.price_per_patient || 0),
        0
      );
      return total.toFixed(2);
    },
    cp_final_price() {
      const total =
        parseFloat(this.cp_total_partial) +
        parseFloat(this.treatment.added_value_price || 0);
      return total.toFixed(2);
    },
    // Excluye materiales ya agregados al tratamiento, igual que tu patrón availableServices
    cp_available_materials() {
      const addedIds = this.treatment.materials.map((m) => m.material_id);
      return this.data_materials_options.filter(
        (opt) => !addedIds.includes(opt.value)
      );
    },
  },
  created() {
    this.mtd_getdata();
    this.mtdGetServiceType();
    this.mtd_getMaterials();
  },
  methods: {
    ...mapActions(["get", "post"]),

    mtd_getdata() {
      const company_id = this.$store.getters.get_company.id;
      const campu_id = this.$store.getters.get_campu.id;
      this.get({
        url: `${this.$store.getters.get__url}/${this.prefix}/index/${company_id}`,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data = response.data.data;
          this.data.forEach((item, i) => { item.index = i + 1; });
        })
        .catch((errors) => console.log(errors));
    },
    mtdGetServiceType() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/service/byTypeService/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.forEach((element) => {
            this.data_serviceType.push({
              label: element.name,
              value: element.id,
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    mtd_getMaterials() {
      const company_id = this.$store.getters.get_company.id;
      const campu_id = this.$store.getters.get_campu.id;
      this.get({
        url: `${this.$store.getters.get__url}/material/index/${company_id}/${campu_id}`,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data_materials = response.data.data;
          this.data_materials_options = this.data_materials
            .filter((m) => m.state == 1)
            .map((m) => ({
              label: `${m.name} (${m.unit_name})`,
              value: m.Id,
            }));
        })
        .catch((errors) => console.log(errors));
    },

    mtdBack() {
      this.$emit("mtdBack");
    },

    mtd_open_modal(boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      this.modal.title = action === "store" ? "Nuevo Tratamiento" : "Editar Tratamiento";
      this.selected_material = null;
      this.preview = emptyPreview();

      if (action === "store") {
        this.treatment = emptyTreatment(this.$store);
      } else {
        this.componentKey += 1;
      }

    },

    mtd_on_material_select(option) {
      if (!option) {
        this.preview = emptyPreview();
        return;
      }
      const mat = this.data_materials.find((m) => m.Id === option.value);
      if (mat) {
        this.preview = {
          material_id: mat.Id,
          material_name: mat.name,
          unit_id: mat.unit_id,
          unit_name: mat.unit_name,
          quantity: mat.unit_conversion,
          price_total: mat.price_total,
          quantity_per_patient: "",
          price_per_patient: 0,
        };
      }
    },

    // price_per_patient = (price_total × quantity_per_patient) / quantity
    mtd_calc_price_per_patient() {
      const qty = parseFloat(this.preview.quantity) || 0;
      const price = parseFloat(this.preview.price_total) || 0;
      const qxp = parseFloat(this.preview.quantity_per_patient) || 0;
      this.preview.price_per_patient =
        qty > 0 && qxp > 0
          ? parseFloat(((price / qty) * qxp).toFixed(2))
          : 0;
    },

    mtd_add_material() {
      if (!this.selected_material) return;

      if (!this.preview.quantity_per_patient || parseFloat(this.preview.quantity_per_patient) <= 0) {
        Swal.fire({ title: "Ingrese la cantidad por paciente", icon: "warning" });
        return;
      }

      this.treatment.materials.push({ ...this.preview });
      this.selected_material = null;
      this.preview = emptyPreview();
    },

    mtd_remove_material(index) {
      this.treatment.materials.splice(index, 1);
    },

    mtd_action() {
      const payload = {
        id: this.treatment.id,
        company_id: this.treatment.company_id,
        campu_id: this.treatment.campu_id,
        name: this.treatment.name,
        added_value_price: this.treatment.added_value_price || 0,
        price: this.treatment.price || 0,
        state: this.treatment.state,
        quotes_quantity: this.treatment.quotes_quantity,
        service_type_id: this.treatment.service_type_id,
        materials: this.treatment.materials.map((m) => ({
          material_id: m.material_id,
          quantity_per_patient: m.quantity_per_patient,
          price_per_patient: m.price_per_patient,
        })),
      };

      this.post({
        url: `${this.$store.getters.get__url}/${this.prefix}/${this.modal.action}`,
        token: this.$store.getters.get__token,
        params: payload,
      })
        .then((response) => {
          if (response.data.state == 1) {
            Swal.fire({ title: "Tratamiento ya registrado", icon: "warning" });
            return;
          }
          const message = this.modal.action === "store"
            ? "REGISTRADO CORRECTAMENTE"
            : "EDITADO CORRECTAMENTE";

          this.treatment = emptyTreatment(this.$store);
          this.modal = { action: "", title: "", modal_form: false };
          this.selected_material = null;
          this.preview = emptyPreview();
          this.mtd_getdata();
          Swal.fire({ title: message, icon: "success" });
        })
        .catch((errors) => {
          Swal.fire({ title: "Error en la operación", icon: "error" });
          console.log(errors);
        });
    },

    mtd_show(id) {
      this.get({
        url: `${this.$store.getters.get__url}/${this.prefix}/show/${id}`,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          const data = response.data.data;
          this.treatment = {
            id: data.Id,
            company_id: data.company_id,
            campu_id: data.campu_id,
            name: data.name,
            added_value_price: data.added_value_price,
            price: data.price,
            quotes_quantity: data.quotes_quantity,
            service_type_id: data.service_type_id,
            state: data.state,
            materials: data.materials.map((m) => ({
              material_id: m.material_id,
              material_name: m.material_name,
              unit_id: m.unit_id,
              unit_name: m.unit_name,
              quantity: m.unit_conversion,
              price_total: m.price_total,
              quantity_per_patient: m.quantity_per_patient,
              price_per_patient: m.price_per_patient,
            })),
          };
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => console.log(errors));
    },

    mtd_delete(item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },

    mtd_commit() {
      this.post({
        url: `${this.$store.getters.get__url}/${this.prefix}/destroy`,
        token: this.$store.getters.get__token,
        params: { id: this.modal_delete.item.Id },
      })
        .then(() => {
          this.mtd_getdata();
          this.modal_delete = { boo: false, item: [] };
          Swal.fire({ title: "ELIMINADO CORRECTAMENTE", icon: "success" });
        })
        .catch((errors) => console.log(errors));
    },

    changeSwitch(payload) {
      this.treatment.state = payload ? 1 : 0;
    },

    validateDecimal(field) {
      let val = String(this.treatment[field]).replace(/[^\d.]/g, "");
      const pts = val.split(".");
      if (pts[1] && pts[1].length > 2) pts[1] = pts[1].substring(0, 2);
      val = pts.length > 2 ? `${pts[0]}.${pts[1]}` : pts.join(".");
      if (parseFloat(val) < 0) val = "0";
      this.treatment[field] = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}

thead.thead-dark th {
  background-color: #343a40;
  color: #fff;
  font-size: 0.78rem;
}

tfoot tr td {
  font-size: 0.85rem;
}
</style>